export const defaultDashboardData = {
  data:  [
              {
                id: 'LMM5ZwPRYdjD1bVfaBLsV',
                name: [
                  'temperature'
                ],
                title: 'Ambient Temperature',
                location: 'q7qszwc1',
                deviceNames: [
                  'B3-92C',
                  'B4-820',
                  'B1-97C',
                  'B5-7BA'
                ],
                devices: [
                  '600a0c2a69e6092c',
                  '600a0c2a69e60820',
                  '600a0c2a69e6097c',
                  '600a0c2a69e607ba'
                ],
                comparison: true,
                sensorsList: [
                  'scd42_62'
                ],
                options: {
                  fill: {
                    colors: [
                      '#b702d4',
                      '#008fd4',
                      '#dbf705',
                      '#00ff1a'
                    ],
                    opacity: 1
                  },
                  stroke: {
                    width: 2,
                    curve: 'smooth',
                    colors: [
                      '#b702d4',
                      '#008fd4',
                      '#dbf705',
                      '#00ff1a'
                    ]
                  },
                  chart: {
                    id: 'realtime',
                    type: 'line',
                    animations: {
                      enabled: true,
                      easing: 'linear',
                      dynamicAnimation: {
                        speed: 1000
                      },
                      toolbar: {
                        show: true
                      }
                    },
                    toolbar: {
                      show: true
                    },
                    zoom: {
                      enabled: true
                    }
                  },
                  grid: {
                    borderColor: '#A3A5A6',
                    xaxis: {
                      lines: {
                        show: true
                      }
                    },
                    yaxis: {
                      lines: {
                        show: true
                      },
                      labels: {}
                    },
                    padding: {
                      top: 0,
                      right: 0,
                      bottom: 0,
                      left: 20
                    }
                  },
                  xaxis: {
                    type: 'datetime'
                  },
                  yaxis: {
                    labels: {},
                    title: {
                      text: 'Temp °F',
                      rotate: -90,
                      offsetX: 0,
                      offsetY: 0,
                      style: {
                        fontSize: '12px',
                        fontFamily: 'Helvetica, Arial, sans-serif',
                        fontWeight: 600,
                        cssClass: 'apexcharts-yaxis-title'
                      }
                    }
                  },
                  dataLabels: {
                    enabled: false
                  },
                  colors: [
                    '#b702d4',
                    '#008fd4',
                    '#dbf705',
                    '#00ff1a'
                  ],
                  annotations: {
                    yaxis: [
                      {
                        y: 68,
                        y2: 73,
                        borderColor: '#98E565',
                        fillColor: '#98E565'
                      },
                      {
                        y: 68,
                        y2: 73,
                        borderColor: '#FFEF5C',
                        fillColor: '#FFEF5C'
                      }
                    ]
                  }
                },
                type: 'normal',
                indicators: true
              },
              {
                id: '59WUGFxSqxNRvah1Ny6QU',
                name: [
                  'ch4'
                ],
                title: 'CH4',
                location: 'q7qszwc1',
                deviceNames: [
                  'B3-92C',
                  'B4-820',
                  'B1-97C',
                  'B5-7BA'
                ],
                devices: [
                  '600a0c2a69e6092c',
                  '600a0c2a69e60820',
                  '600a0c2a69e6097c',
                  '600a0c2a69e607ba'
                ],
                comparison: true,
                sensorsList: [
                  'scd41_62',
                  'mcp3424_6A',
                  'mcp3424_6E',
                  'sfa30_5D',
                  'sen54_69',
                  'scd42_62'
                ],
                options: {
                  fill: {
                    colors: [
                      '#b702d4',
                      '#008fd4',
                      '#dbf705',
                      '#00ff1a'
                    ],
                    opacity: 1
                  },
                  stroke: {
                    width: 2,
                    curve: 'straight',
                    colors: [
                      '#b702d4',
                      '#008fd4',
                      '#dbf705',
                      '#00ff1a'
                    ]
                  },
                  chart: {
                    id: 'realtime',
                    type: 'line',
                    animations: {
                      enabled: true,
                      easing: 'linear',
                      dynamicAnimation: {
                        speed: 1000
                      },
                      toolbar: {
                        show: true
                      }
                    },
                    toolbar: {
                      show: true
                    },
                    zoom: {
                      enabled: true
                    }
                  },
                  grid: {
                    borderColor: '#A3A5A6',
                    xaxis: {
                      lines: {
                        show: true
                      }
                    },
                    yaxis: {
                      lines: {
                        show: true
                      },
                      labels: {}
                    },
                    padding: {
                      top: 0,
                      right: 0,
                      bottom: 0,
                      left: 20
                    }
                  },
                  xaxis: {
                    type: 'datetime'
                  },
                  yaxis: {
                    labels: {},
                    title: {
                      text: 'PPM',
                      rotate: -90,
                      offsetX: 0,
                      offsetY: 0,
                      style: {
                        fontSize: '12px',
                        fontFamily: 'Helvetica, Arial, sans-serif',
                        fontWeight: 600,
                        cssClass: 'apexcharts-yaxis-title'
                      }
                    }
                  },
                  dataLabels: {
                    enabled: false
                  },
                  colors: [
                    '#b702d4',
                    '#008fd4',
                    '#dbf705',
                    '#00ff1a'
                  ],
                  annotations: {
                    yaxis: [
                      {
                        y: -99999,
                        y2: 1000,
                        borderColor: '#98E565',
                        fillColor: '#98E565'
                      },
                      {
                        y: 1000,
                        y2: 4000,
                        borderColor: '#FFEF5C',
                        fillColor: '#FFEF5C'
                      },
                      {
                        y: 4000,
                        y2: 0,
                        borderColor: '#871014',
                        fillColor: '#871014'
                      }
                    ]
                  }
                },
                type: 'normal',
                indicators: true
              },
              {
                id: 'Tkp5ZneMhxWC-s9xdoyrA',
                name: [
                  'humidity'
                ],
                title: 'Relative Humidity',
                location: 'q7qszwc1',
                deviceNames: [
                  'B3-92C',
                  'B4-820',
                  'B1-97C',
                  'B5-7BA'
                ],
                devices: [
                  '600a0c2a69e6092c',
                  '600a0c2a69e60820',
                  '600a0c2a69e6097c',
                  '600a0c2a69e607ba'
                ],
                comparison: true,
                sensorsList: [
                  'scd42_62'
                ],
                options: {
                  fill: {
                    colors: [
                      '#b702d4',
                      '#008fd4',
                      '#dbf705',
                      '#00ff1a'
                    ],
                    opacity: 1
                  },
                  stroke: {
                    width: 2,
                    curve: 'straight',
                    colors: [
                      '#b702d4',
                      '#008fd4',
                      '#dbf705',
                      '#00ff1a'
                    ]
                  },
                  chart: {
                    id: 'realtime',
                    type: 'line',
                    animations: {
                      enabled: true,
                      easing: 'linear',
                      dynamicAnimation: {
                        speed: 1000
                      },
                      toolbar: {
                        show: true
                      }
                    },
                    toolbar: {
                      show: true
                    },
                    zoom: {
                      enabled: true
                    }
                  },
                  grid: {
                    borderColor: '#A3A5A6',
                    xaxis: {
                      lines: {
                        show: true
                      }
                    },
                    yaxis: {
                      lines: {
                        show: true
                      },
                      labels: {}
                    },
                    padding: {
                      top: 0,
                      right: 0,
                      bottom: 0,
                      left: 20
                    }
                  },
                  xaxis: {
                    type: 'datetime'
                  },
                  yaxis: {
                    labels: {},
                    title: {
                      text: '%RH',
                      rotate: -90,
                      offsetX: 0,
                      offsetY: 0,
                      style: {
                        fontSize: '12px',
                        fontFamily: 'Helvetica, Arial, sans-serif',
                        fontWeight: 600,
                        cssClass: 'apexcharts-yaxis-title'
                      }
                    }
                  },
                  dataLabels: {
                    enabled: false
                  },
                  colors: [
                    '#b702d4',
                    '#008fd4',
                    '#dbf705',
                    '#00ff1a'
                  ],
                  annotations: {
                    yaxis: [
                      {
                        y: 40,
                        y2: 60,
                        borderColor: '#98E565',
                        fillColor: '#98E565'
                      },
                      {
                        y: 40,
                        y2: 60,
                        borderColor: '#FFEF5C',
                        fillColor: '#FFEF5C'
                      }
                    ]
                  }
                },
                type: 'normal',
                indicators: true
              },
              {
                id: 'r5MIV7ZQ_pmSr2FL-2YZm',
                name: [
                  'voc'
                ],
                title: 'VOC',
                location: 'q7qszwc1',
                deviceNames: [
                  'B3-92C',
                  'B4-820',
                  'B1-97C',
                  'B5-7BA'
                ],
                devices: [
                  '600a0c2a69e6092c',
                  '600a0c2a69e60820',
                  '600a0c2a69e6097c',
                  '600a0c2a69e607ba'
                ],
                comparison: true,
                sensorsList: [
                  'scd41_62',
                  'mcp3424_6A',
                  'mcp3424_6E',
                  'sfa30_5D',
                  'sen54_69',
                  'scd42_62'
                ],
                options: {
                  fill: {
                    colors: [
                      '#b702d4',
                      '#008fd4',
                      '#dbf705',
                      '#00ff1a'
                    ],
                    opacity: 1
                  },
                  stroke: {
                    width: 2,
                    curve: 'straight',
                    colors: [
                      '#b702d4',
                      '#008fd4',
                      '#dbf705',
                      '#00ff1a'
                    ]
                  },
                  chart: {
                    id: 'realtime',
                    type: 'line',
                    animations: {
                      enabled: true,
                      easing: 'linear',
                      dynamicAnimation: {
                        speed: 1000
                      },
                      toolbar: {
                        show: true
                      }
                    },
                    toolbar: {
                      show: true
                    },
                    zoom: {
                      enabled: true
                    }
                  },
                  grid: {
                    borderColor: '#A3A5A6',
                    xaxis: {
                      lines: {
                        show: true
                      }
                    },
                    yaxis: {
                      lines: {
                        show: true
                      },
                      labels: {}
                    },
                    padding: {
                      top: 0,
                      right: 0,
                      bottom: 0,
                      left: 20
                    }
                  },
                  xaxis: {
                    type: 'datetime'
                  },
                  yaxis: {
                    labels: {},
                    title: {
                      text: 'Index',
                      rotate: -90,
                      offsetX: 0,
                      offsetY: 0,
                      style: {
                        fontSize: '12px',
                        fontFamily: 'Helvetica, Arial, sans-serif',
                        fontWeight: 600,
                        cssClass: 'apexcharts-yaxis-title'
                      }
                    }
                  },
                  dataLabels: {
                    enabled: false
                  },
                  colors: [
                    '#b702d4',
                    '#008fd4',
                    '#dbf705',
                    '#00ff1a'
                  ],
                  annotations: {
                    yaxis: [
                      {
                        y: -1,
                        y2: 125,
                        borderColor: '#98E565',
                        fillColor: '#98E565'
                      },
                      {
                        y: 125,
                        y2: 500,
                        borderColor: '#FFEF5C',
                        fillColor: '#FFEF5C'
                      }
                    ]
                  }
                },
                type: 'normal',
                indicators: true
              },
              {
                id: 'Px9nAv4NB3jfnxDTAsu30',
                name: [
                  'pm10psd'
                ],
                title: 'Particulate Matter (Count) 10.0',
                location: 'q7qszwc1',
                deviceNames: [
                  'B3-92C',
                  'B4-820',
                  'B1-97C',
                  'B5-7BA'
                ],
                devices: [
                  '600a0c2a69e6092c',
                  '600a0c2a69e60820',
                  '600a0c2a69e6097c',
                  '600a0c2a69e607ba'
                ],
                comparison: true,
                sensorsList: [
                  'scd41_62',
                  'mcp3424_6A',
                  'sfa30_5D',
                  'mcp3424_6E',
                  'sen54_69',
                  'scd42_62'
                ],
                options: {
                  fill: {
                    colors: [
                      '#b702d4',
                      '#008fd4',
                      '#dbf705',
                      '#00ff1a'
                    ],
                    opacity: 1
                  },
                  stroke: {
                    width: 2,
                    curve: 'straight',
                    colors: [
                      '#b702d4',
                      '#008fd4',
                      '#dbf705',
                      '#00ff1a'
                    ]
                  },
                  chart: {
                    id: 'realtime',
                    type: 'line',
                    animations: {
                      enabled: true,
                      easing: 'linear',
                      dynamicAnimation: {
                        speed: 1000
                      },
                      toolbar: {
                        show: true
                      }
                    },
                    toolbar: {
                      show: true
                    },
                    zoom: {
                      enabled: true
                    }
                  },
                  grid: {
                    borderColor: '#A3A5A6',
                    xaxis: {
                      lines: {
                        show: true
                      }
                    },
                    yaxis: {
                      lines: {
                        show: true
                      },
                      labels: {}
                    },
                    padding: {
                      top: 0,
                      right: 0,
                      bottom: 0,
                      left: 20
                    }
                  },
                  xaxis: {
                    type: 'datetime'
                  },
                  yaxis: {
                    labels: {},
                    title: {
                      text: '#M/m3',
                      rotate: -90,
                      offsetX: 0,
                      offsetY: 0,
                      style: {
                        fontSize: '12px',
                        fontFamily: 'Helvetica, Arial, sans-serif',
                        fontWeight: 600,
                        cssClass: 'apexcharts-yaxis-title'
                      }
                    }
                  },
                  dataLabels: {
                    enabled: false
                  },
                  colors: [
                    '#b702d4',
                    '#008fd4',
                    '#dbf705',
                    '#00ff1a'
                  ],
                  annotations: {
                    yaxis: []
                  }
                },
                type: 'normal',
                indicators: true
              },
              {
                id: '6gyo5x3GRxxJed-_V891o',
                name: [
                  'pm4psd'
                ],
                title: 'Particulate Matter (Count) 4.0',
                location: 'q7qszwc1',
                deviceNames: [
                  'B3-92C',
                  'B4-820',
                  'B1-97C',
                  'B5-7BA'
                ],
                devices: [
                  '600a0c2a69e6092c',
                  '600a0c2a69e60820',
                  '600a0c2a69e6097c',
                  '600a0c2a69e607ba'
                ],
                comparison: true,
                sensorsList: [
                  'scd41_62',
                  'mcp3424_6A',
                  'mcp3424_6E',
                  'sfa30_5D',
                  'sen54_69',
                  'scd42_62'
                ],
                options: {
                  fill: {
                    colors: [
                      '#b702d4',
                      '#008fd4',
                      '#dbf705',
                      '#00ff1a'
                    ],
                    opacity: 1
                  },
                  stroke: {
                    width: 2,
                    curve: 'straight',
                    colors: [
                      '#b702d4',
                      '#008fd4',
                      '#dbf705',
                      '#00ff1a'
                    ]
                  },
                  chart: {
                    id: 'realtime',
                    type: 'line',
                    animations: {
                      enabled: true,
                      easing: 'linear',
                      dynamicAnimation: {
                        speed: 1000
                      },
                      toolbar: {
                        show: true
                      }
                    },
                    toolbar: {
                      show: true
                    },
                    zoom: {
                      enabled: true
                    }
                  },
                  grid: {
                    borderColor: '#A3A5A6',
                    xaxis: {
                      lines: {
                        show: true
                      }
                    },
                    yaxis: {
                      lines: {
                        show: true
                      },
                      labels: {}
                    },
                    padding: {
                      top: 0,
                      right: 0,
                      bottom: 0,
                      left: 20
                    }
                  },
                  xaxis: {
                    type: 'datetime'
                  },
                  yaxis: {
                    labels: {},
                    title: {
                      text: '#M/m3',
                      rotate: -90,
                      offsetX: 0,
                      offsetY: 0,
                      style: {
                        fontSize: '12px',
                        fontFamily: 'Helvetica, Arial, sans-serif',
                        fontWeight: 600,
                        cssClass: 'apexcharts-yaxis-title'
                      }
                    }
                  },
                  dataLabels: {
                    enabled: false
                  },
                  colors: [
                    '#b702d4',
                    '#008fd4',
                    '#dbf705',
                    '#00ff1a'
                  ],
                  annotations: {
                    yaxis: []
                  }
                },
                type: 'normal',
                indicators: true
              },
              {
                id: 'ap9gjqQIlqKGkR9whZe6b',
                name: [
                  'tps'
                ],
                title: 'TPS',
                location: 'q7qszwc1',
                deviceNames: [
                  'B3-92C',
                  'B4-820',
                  'B1-97C',
                  'B5-7BA'
                ],
                devices: [
                  '600a0c2a69e6092c',
                  '600a0c2a69e60820',
                  '600a0c2a69e6097c',
                  '600a0c2a69e607ba'
                ],
                comparison: true,
                sensorsList: [
                  'scd41_62',
                  'mcp3424_6A',
                  'mcp3424_6E',
                  'sfa30_5D',
                  'sen54_69',
                  'scd42_62'
                ],
                options: {
                  fill: {
                    colors: [
                      '#b702d4',
                      '#008fd4',
                      '#dbf705',
                      '#00ff1a'
                    ],
                    opacity: 1
                  },
                  stroke: {
                    width: 2,
                    curve: 'straight',
                    colors: [
                      '#b702d4',
                      '#008fd4',
                      '#dbf705',
                      '#00ff1a'
                    ]
                  },
                  chart: {
                    id: 'realtime',
                    type: 'line',
                    animations: {
                      enabled: true,
                      easing: 'linear',
                      dynamicAnimation: {
                        speed: 1000
                      },
                      toolbar: {
                        show: true
                      }
                    },
                    toolbar: {
                      show: true
                    },
                    zoom: {
                      enabled: true
                    }
                  },
                  grid: {
                    borderColor: '#A3A5A6',
                    xaxis: {
                      lines: {
                        show: true
                      }
                    },
                    yaxis: {
                      lines: {
                        show: true
                      },
                      labels: {}
                    },
                    padding: {
                      top: 0,
                      right: 0,
                      bottom: 0,
                      left: 20
                    }
                  },
                  xaxis: {
                    type: 'datetime'
                  },
                  yaxis: {
                    labels: {},
                    title: {
                      text: 'Typical Particle Size [μm]',
                      rotate: -90,
                      offsetX: 0,
                      offsetY: 0,
                      style: {
                        fontSize: '12px',
                        fontFamily: 'Helvetica, Arial, sans-serif',
                        fontWeight: 600,
                        cssClass: 'apexcharts-yaxis-title'
                      }
                    }
                  },
                  dataLabels: {
                    enabled: false
                  },
                  colors: [
                    '#b702d4',
                    '#008fd4',
                    '#dbf705',
                    '#00ff1a'
                  ],
                  annotations: {
                    yaxis: []
                  }
                },
                type: 'normal',
                indicators: true
              },
              {
                id: 'xfSCFsA0Syn9ql6y_5CX_',
                name: [
                  'pm2dot5psd'
                ],
                title: 'Particulate Matter (Count) 2.5',
                location: 'q7qszwc1',
                deviceNames: [
                  'B3-92C',
                  'B4-820',
                  'B1-97C',
                  'B5-7BA'
                ],
                devices: [
                  '600a0c2a69e6092c',
                  '600a0c2a69e60820',
                  '600a0c2a69e6097c',
                  '600a0c2a69e607ba'
                ],
                comparison: true,
                sensorsList: [
                  'scd41_62',
                  'mcp3424_6A',
                  'mcp3424_6E',
                  'sfa30_5D',
                  'sen54_69',
                  'scd42_62'
                ],
                options: {
                  fill: {
                    colors: [
                      '#b702d4',
                      '#008fd4',
                      '#dbf705',
                      '#00ff1a'
                    ],
                    opacity: 1
                  },
                  stroke: {
                    width: 2,
                    curve: 'straight',
                    colors: [
                      '#b702d4',
                      '#008fd4',
                      '#dbf705',
                      '#00ff1a'
                    ]
                  },
                  chart: {
                    id: 'realtime',
                    type: 'line',
                    animations: {
                      enabled: true,
                      easing: 'linear',
                      dynamicAnimation: {
                        speed: 1000
                      },
                      toolbar: {
                        show: true
                      }
                    },
                    toolbar: {
                      show: true
                    },
                    zoom: {
                      enabled: true
                    }
                  },
                  grid: {
                    borderColor: '#A3A5A6',
                    xaxis: {
                      lines: {
                        show: true
                      }
                    },
                    yaxis: {
                      lines: {
                        show: true
                      },
                      labels: {}
                    },
                    padding: {
                      top: 0,
                      right: 0,
                      bottom: 0,
                      left: 20
                    }
                  },
                  xaxis: {
                    type: 'datetime'
                  },
                  yaxis: {
                    labels: {},
                    title: {
                      text: '#M/m3',
                      rotate: -90,
                      offsetX: 0,
                      offsetY: 0,
                      style: {
                        fontSize: '12px',
                        fontFamily: 'Helvetica, Arial, sans-serif',
                        fontWeight: 600,
                        cssClass: 'apexcharts-yaxis-title'
                      }
                    }
                  },
                  dataLabels: {
                    enabled: false
                  },
                  colors: [
                    '#b702d4',
                    '#008fd4',
                    '#dbf705',
                    '#00ff1a'
                  ],
                  annotations: {
                    yaxis: []
                  }
                },
                type: 'normal',
                indicators: true
              },
              {
                id: 'NZLkDlmNLxgVPYpRLdB0d',
                name: [
                  'pm1psd'
                ],
                title: 'Particulate Matter (Count) 1',
                location: 'q7qszwc1',
                deviceNames: [
                  'B3-92C',
                  'B4-820',
                  'B1-97C',
                  'B5-7BA'
                ],
                devices: [
                  '600a0c2a69e6092c',
                  '600a0c2a69e60820',
                  '600a0c2a69e6097c',
                  '600a0c2a69e607ba'
                ],
                comparison: true,
                sensorsList: [
                  'scd41_62',
                  'mcp3424_6A',
                  'mcp3424_6E',
                  'sfa30_5D',
                  'sen54_69',
                  'scd42_62'
                ],
                options: {
                  fill: {
                    colors: [
                      '#b702d4',
                      '#008fd4',
                      '#dbf705',
                      '#00ff1a'
                    ],
                    opacity: 1
                  },
                  stroke: {
                    width: 2,
                    curve: 'straight',
                    colors: [
                      '#b702d4',
                      '#008fd4',
                      '#dbf705',
                      '#00ff1a'
                    ]
                  },
                  chart: {
                    id: 'realtime',
                    type: 'line',
                    animations: {
                      enabled: true,
                      easing: 'linear',
                      dynamicAnimation: {
                        speed: 1000
                      },
                      toolbar: {
                        show: true
                      }
                    },
                    toolbar: {
                      show: true
                    },
                    zoom: {
                      enabled: true
                    }
                  },
                  grid: {
                    borderColor: '#A3A5A6',
                    xaxis: {
                      lines: {
                        show: true
                      }
                    },
                    yaxis: {
                      lines: {
                        show: true
                      },
                      labels: {}
                    },
                    padding: {
                      top: 0,
                      right: 0,
                      bottom: 0,
                      left: 20
                    }
                  },
                  xaxis: {
                    type: 'datetime'
                  },
                  yaxis: {
                    labels: {},
                    title: {
                      text: '#M/m3',
                      rotate: -90,
                      offsetX: 0,
                      offsetY: 0,
                      style: {
                        fontSize: '12px',
                        fontFamily: 'Helvetica, Arial, sans-serif',
                        fontWeight: 600,
                        cssClass: 'apexcharts-yaxis-title'
                      }
                    }
                  },
                  dataLabels: {
                    enabled: false
                  },
                  colors: [
                    '#b702d4',
                    '#008fd4',
                    '#dbf705',
                    '#00ff1a'
                  ],
                  annotations: {
                    yaxis: []
                  }
                },
                type: 'normal',
                indicators: true
              },
              {
                id: 'avoQOIYLYMGTby25S1UEe',
                name: [
                  'pm0dot5psd'
                ],
                title: 'Particulate Matter (Count) 0.5',
                location: 'q7qszwc1',
                deviceNames: [
                  'B3-92C',
                  'B4-820',
                  'B1-97C',
                  'B5-7BA'
                ],
                devices: [
                  '600a0c2a69e6092c',
                  '600a0c2a69e60820',
                  '600a0c2a69e6097c',
                  '600a0c2a69e607ba'
                ],
                comparison: true,
                sensorsList: [
                  'scd41_62',
                  'mcp3424_6A',
                  'mcp3424_6E',
                  'sfa30_5D',
                  'sen54_69',
                  'scd42_62'
                ],
                options: {
                  fill: {
                    colors: [
                      '#b702d4',
                      '#008fd4',
                      '#dbf705',
                      '#00ff1a'
                    ],
                    opacity: 1
                  },
                  stroke: {
                    width: 2,
                    curve: 'straight',
                    colors: [
                      '#b702d4',
                      '#008fd4',
                      '#dbf705',
                      '#00ff1a'
                    ]
                  },
                  chart: {
                    id: 'realtime',
                    type: 'line',
                    animations: {
                      enabled: true,
                      easing: 'linear',
                      dynamicAnimation: {
                        speed: 1000
                      },
                      toolbar: {
                        show: true
                      }
                    },
                    toolbar: {
                      show: true
                    },
                    zoom: {
                      enabled: true
                    }
                  },
                  grid: {
                    borderColor: '#A3A5A6',
                    xaxis: {
                      lines: {
                        show: true
                      }
                    },
                    yaxis: {
                      lines: {
                        show: true
                      },
                      labels: {}
                    },
                    padding: {
                      top: 0,
                      right: 0,
                      bottom: 0,
                      left: 20
                    }
                  },
                  xaxis: {
                    type: 'datetime'
                  },
                  yaxis: {
                    labels: {},
                    title: {
                      text: '#M/m3',
                      rotate: -90,
                      offsetX: 0,
                      offsetY: 0,
                      style: {
                        fontSize: '12px',
                        fontFamily: 'Helvetica, Arial, sans-serif',
                        fontWeight: 600,
                        cssClass: 'apexcharts-yaxis-title'
                      }
                    }
                  },
                  dataLabels: {
                    enabled: false
                  },
                  colors: [
                    '#b702d4',
                    '#008fd4',
                    '#dbf705',
                    '#00ff1a'
                  ],
                  annotations: {
                    yaxis: []
                  }
                },
                type: 'normal',
                indicators: true
              },
              {
                id: 'chx7OxsOmFVWjpsGbEEks',
                name: [
                  'pm2dot5psd'
                ],
                title: 'Particulate Matter (Mass) 2.5',
                location: 'q7qszwc1',
                deviceNames: [
                  'B3-92C',
                  'B4-820',
                  'B1-97C',
                  'B5-7BA'
                ],
                devices: [
                  '600a0c2a69e6092c',
                  '600a0c2a69e60820',
                  '600a0c2a69e6097c',
                  '600a0c2a69e607ba'
                ],
                comparison: true,
                sensorsList: [
                  'mcp3424_6E',
                  'sfa30_5D',
                  'sen54_69',
                  'scd42_62',
                  'mcp3424_6A',
                  'scd41_62'
                ],
                options: {
                  fill: {
                    colors: [
                      '#b702d4',
                      '#008fd4',
                      '#dbf705',
                      '#00ff1a'
                    ],
                    opacity: 1
                  },
                  stroke: {
                    width: 2,
                    curve: 'straight',
                    colors: [
                      '#b702d4',
                      '#008fd4',
                      '#dbf705',
                      '#00ff1a'
                    ]
                  },
                  chart: {
                    id: 'realtime',
                    type: 'line',
                    animations: {
                      enabled: true,
                      easing: 'linear',
                      dynamicAnimation: {
                        speed: 1000
                      },
                      toolbar: {
                        show: true
                      }
                    },
                    toolbar: {
                      show: true
                    },
                    zoom: {
                      enabled: true
                    }
                  },
                  grid: {
                    borderColor: '#A3A5A6',
                    xaxis: {
                      lines: {
                        show: true
                      }
                    },
                    yaxis: {
                      lines: {
                        show: true
                      },
                      labels: {}
                    },
                    padding: {
                      top: 0,
                      right: 0,
                      bottom: 0,
                      left: 20
                    }
                  },
                  xaxis: {
                    type: 'datetime'
                  },
                  yaxis: {
                    labels: {},
                    title: {
                      text: '#M/m3',
                      rotate: -90,
                      offsetX: 0,
                      offsetY: 0,
                      style: {
                        fontSize: '12px',
                        fontFamily: 'Helvetica, Arial, sans-serif',
                        fontWeight: 600,
                        cssClass: 'apexcharts-yaxis-title'
                      }
                    }
                  },
                  dataLabels: {
                    enabled: false
                  },
                  colors: [
                    '#b702d4',
                    '#008fd4',
                    '#dbf705',
                    '#00ff1a'
                  ],
                  annotations: {
                    yaxis: []
                  }
                },
                type: 'normal',
                indicators: true
              },
              {
                id: 'wZRRU-m-arVHW3UYPSB5O',
                name: [
                  'pm10psd'
                ],
                title: 'Particulate Matter (Mass) 10.0',
                location: 'q7qszwc1',
                deviceNames: [
                  'B3-92C',
                  'B4-820',
                  'B1-97C',
                  'B5-7BA'
                ],
                devices: [
                  '600a0c2a69e6092c',
                  '600a0c2a69e60820',
                  '600a0c2a69e6097c',
                  '600a0c2a69e607ba'
                ],
                comparison: true,
                sensorsList: [
                  'scd41_62',
                  'mcp3424_6A',
                  'mcp3424_6E',
                  'sfa30_5D',
                  'sen54_69',
                  'scd42_62'
                ],
                options: {
                  fill: {
                    colors: [
                      '#b702d4',
                      '#008fd4',
                      '#dbf705',
                      '#00ff1a'
                    ],
                    opacity: 1
                  },
                  stroke: {
                    width: 2,
                    curve: 'straight',
                    colors: [
                      '#b702d4',
                      '#008fd4',
                      '#dbf705',
                      '#00ff1a'
                    ]
                  },
                  chart: {
                    id: 'realtime',
                    type: 'line',
                    animations: {
                      enabled: true,
                      easing: 'linear',
                      dynamicAnimation: {
                        speed: 1000
                      },
                      toolbar: {
                        show: true
                      }
                    },
                    toolbar: {
                      show: true
                    },
                    zoom: {
                      enabled: true
                    }
                  },
                  grid: {
                    borderColor: '#A3A5A6',
                    xaxis: {
                      lines: {
                        show: true
                      }
                    },
                    yaxis: {
                      lines: {
                        show: true
                      },
                      labels: {}
                    },
                    padding: {
                      top: 0,
                      right: 0,
                      bottom: 0,
                      left: 20
                    }
                  },
                  xaxis: {
                    type: 'datetime'
                  },
                  yaxis: {
                    labels: {},
                    title: {
                      text: '#M/m3',
                      rotate: -90,
                      offsetX: 0,
                      offsetY: 0,
                      style: {
                        fontSize: '12px',
                        fontFamily: 'Helvetica, Arial, sans-serif',
                        fontWeight: 600,
                        cssClass: 'apexcharts-yaxis-title'
                      }
                    }
                  },
                  dataLabels: {
                    enabled: false
                  },
                  colors: [
                    '#b702d4',
                    '#008fd4',
                    '#dbf705',
                    '#00ff1a'
                  ],
                  annotations: {
                    yaxis: []
                  }
                },
                type: 'normal',
                indicators: true
              },
              {
                id: 'M3x1B1WWUAS5fHEpU2lND',
                name: [
                  'pm4psd'
                ],
                title: 'Particulate Matter (Mass) 4.0',
                location: 'q7qszwc1',
                deviceNames: [
                  'B3-92C',
                  'B4-820',
                  'B1-97C',
                  'B5-7BA'
                ],
                devices: [
                  '600a0c2a69e6092c',
                  '600a0c2a69e60820',
                  '600a0c2a69e6097c',
                  '600a0c2a69e607ba'
                ],
                comparison: true,
                sensorsList: [
                  'sfa30_5D',
                  'mcp3424_6E',
                  'mcp3424_6A',
                  'scd41_62',
                  'sen54_69',
                  'scd42_62'
                ],
                options: {
                  fill: {
                    colors: [
                      '#b702d4',
                      '#008fd4',
                      '#dbf705',
                      '#00ff1a'
                    ],
                    opacity: 1
                  },
                  stroke: {
                    width: 2,
                    curve: 'straight',
                    colors: [
                      '#b702d4',
                      '#008fd4',
                      '#dbf705',
                      '#00ff1a'
                    ]
                  },
                  chart: {
                    id: 'realtime',
                    type: 'line',
                    animations: {
                      enabled: true,
                      easing: 'linear',
                      dynamicAnimation: {
                        speed: 1000
                      },
                      toolbar: {
                        show: true
                      }
                    },
                    toolbar: {
                      show: true
                    },
                    zoom: {
                      enabled: true
                    }
                  },
                  grid: {
                    borderColor: '#A3A5A6',
                    xaxis: {
                      lines: {
                        show: true
                      }
                    },
                    yaxis: {
                      lines: {
                        show: true
                      },
                      labels: {}
                    },
                    padding: {
                      top: 0,
                      right: 0,
                      bottom: 0,
                      left: 20
                    }
                  },
                  xaxis: {
                    type: 'datetime'
                  },
                  yaxis: {
                    labels: {},
                    title: {
                      text: '#M/m3',
                      rotate: -90,
                      offsetX: 0,
                      offsetY: 0,
                      style: {
                        fontSize: '12px',
                        fontFamily: 'Helvetica, Arial, sans-serif',
                        fontWeight: 600,
                        cssClass: 'apexcharts-yaxis-title'
                      }
                    }
                  },
                  dataLabels: {
                    enabled: false
                  },
                  colors: [
                    '#b702d4',
                    '#008fd4',
                    '#dbf705',
                    '#00ff1a'
                  ],
                  annotations: {
                    yaxis: []
                  }
                },
                type: 'normal',
                indicators: true
              },
              {
                id: 'XnyrrxOZNjoKg7mICwRdl',
                name: [
                  'pm1psd'
                ],
                title: 'Particulate Matter (Mass) 1',
                location: 'q7qszwc1',
                deviceNames: [
                  'B3-92C',
                  'B4-820',
                  'B1-97C',
                  'B5-7BA'
                ],
                devices: [
                  '600a0c2a69e6092c',
                  '600a0c2a69e60820',
                  '600a0c2a69e6097c',
                  '600a0c2a69e607ba'
                ],
                comparison: true,
                sensorsList: [
                  'scd41_62',
                  'mcp3424_6A',
                  'mcp3424_6E',
                  'sfa30_5D',
                  'sen54_69',
                  'scd42_62'
                ],
                options: {
                  fill: {
                    colors: [
                      '#b702d4',
                      '#008fd4',
                      '#dbf705',
                      '#00ff1a'
                    ],
                    opacity: 1
                  },
                  stroke: {
                    width: 2,
                    curve: 'straight',
                    colors: [
                      '#b702d4',
                      '#008fd4',
                      '#dbf705',
                      '#00ff1a'
                    ]
                  },
                  chart: {
                    id: 'realtime',
                    type: 'line',
                    animations: {
                      enabled: true,
                      easing: 'linear',
                      dynamicAnimation: {
                        speed: 1000
                      },
                      toolbar: {
                        show: true
                      }
                    },
                    toolbar: {
                      show: true
                    },
                    zoom: {
                      enabled: true
                    }
                  },
                  grid: {
                    borderColor: '#A3A5A6',
                    xaxis: {
                      lines: {
                        show: true
                      }
                    },
                    yaxis: {
                      lines: {
                        show: true
                      },
                      labels: {}
                    },
                    padding: {
                      top: 0,
                      right: 0,
                      bottom: 0,
                      left: 20
                    }
                  },
                  xaxis: {
                    type: 'datetime'
                  },
                  yaxis: {
                    labels: {},
                    title: {
                      text: '#M/m3',
                      rotate: -90,
                      offsetX: 0,
                      offsetY: 0,
                      style: {
                        fontSize: '12px',
                        fontFamily: 'Helvetica, Arial, sans-serif',
                        fontWeight: 600,
                        cssClass: 'apexcharts-yaxis-title'
                      }
                    }
                  },
                  dataLabels: {
                    enabled: false
                  },
                  colors: [
                    '#b702d4',
                    '#008fd4',
                    '#dbf705',
                    '#00ff1a'
                  ],
                  annotations: {
                    yaxis: []
                  }
                },
                type: 'normal',
                indicators: true
              },
              {
                id: 'LJfzeH083nTpFb8TY1tJn',
                name: [
                  'co2'
                ],
                title: 'Carbon Dioxide',
                location: 'q7qszwc1',
                deviceNames: [
                  'B3-92C',
                  'B4-820',
                  'B1-97C',
                  'B5-7BA'
                ],
                devices: [
                  '600a0c2a69e6092c',
                  '600a0c2a69e60820',
                  '600a0c2a69e6097c',
                  '600a0c2a69e607ba'
                ],
                comparison: true,
                sensorsList: [
                  'scd41_62',
                  'mcp3424_6A',
                  'mcp3424_6E',
                  'sfa30_5D',
                  'sen54_69',
                  'scd42_62'
                ],
                options: {
                  fill: {
                    colors: [
                      '#b702d4',
                      '#008fd4',
                      '#dbf705',
                      '#00ff1a'
                    ],
                    opacity: 1
                  },
                  stroke: {
                    width: 2,
                    curve: 'straight',
                    colors: [
                      '#b702d4',
                      '#008fd4',
                      '#dbf705',
                      '#00ff1a'
                    ]
                  },
                  chart: {
                    id: 'realtime',
                    type: 'line',
                    animations: {
                      enabled: true,
                      easing: 'linear',
                      dynamicAnimation: {
                        speed: 1000
                      },
                      toolbar: {
                        show: true
                      }
                    },
                    toolbar: {
                      show: true
                    },
                    zoom: {
                      enabled: true
                    }
                  },
                  grid: {
                    borderColor: '#A3A5A6',
                    xaxis: {
                      lines: {
                        show: true
                      }
                    },
                    yaxis: {
                      lines: {
                        show: true
                      },
                      labels: {}
                    },
                    padding: {
                      top: 0,
                      right: 0,
                      bottom: 0,
                      left: 20
                    }
                  },
                  xaxis: {
                    type: 'datetime'
                  },
                  yaxis: {
                    labels: {},
                    title: {
                      text: 'PPM',
                      rotate: -90,
                      offsetX: 0,
                      offsetY: 0,
                      style: {
                        fontSize: '12px',
                        fontFamily: 'Helvetica, Arial, sans-serif',
                        fontWeight: 600,
                        cssClass: 'apexcharts-yaxis-title'
                      }
                    }
                  },
                  dataLabels: {
                    enabled: false
                  },
                  colors: [
                    '#b702d4',
                    '#008fd4',
                    '#dbf705',
                    '#00ff1a'
                  ],
                  annotations: {
                    yaxis: [
                      {
                        y: 0,
                        y2: 1000,
                        borderColor: '#98E565',
                        fillColor: '#98E565'
                      },
                      {
                        y: 1000,
                        y2: 7000,
                        borderColor: '#FFEF5C',
                        fillColor: '#FFEF5C'
                      },
                      {
                        y: 7000,
                        y2: 40000,
                        borderColor: '#871014',
                        fillColor: '#871014'
                      },
                      {
                        y: 40000,
                        y2: 0,
                        borderColor: '#000000',
                        fillColor: '#000000'
                      }
                    ]
                  }
                },
                type: 'normal',
                indicators: true
              },
              {
                id: 'Yg0FH5W14NxcYhMdMChv6',
                name: [
                  'co'
                ],
                title: 'Carbon Monoxide',
                location: 'q7qszwc1',
                deviceNames: [
                  'B3-92C',
                  'B4-820',
                  'B1-97C',
                  'B5-7BA'
                ],
                devices: [
                  '600a0c2a69e6092c',
                  '600a0c2a69e60820',
                  '600a0c2a69e6097c',
                  '600a0c2a69e607ba'
                ],
                comparison: true,
                sensorsList: [
                  'scd41_62',
                  'mcp3424_6A',
                  'mcp3424_6E',
                  'sfa30_5D',
                  'sen54_69',
                  'scd42_62'
                ],
                options: {
                  fill: {
                    colors: [
                      '#b702d4',
                      '#008fd4',
                      '#dbf705',
                      '#00ff1a'
                    ],
                    opacity: 1
                  },
                  stroke: {
                    width: 2,
                    curve: 'straight',
                    colors: [
                      '#b702d4',
                      '#008fd4',
                      '#dbf705',
                      '#00ff1a'
                    ]
                  },
                  chart: {
                    id: 'realtime',
                    type: 'line',
                    animations: {
                      enabled: true,
                      easing: 'linear',
                      dynamicAnimation: {
                        speed: 1000
                      },
                      toolbar: {
                        show: true
                      }
                    },
                    toolbar: {
                      show: true
                    },
                    zoom: {
                      enabled: true
                    }
                  },
                  grid: {
                    borderColor: '#A3A5A6',
                    xaxis: {
                      lines: {
                        show: true
                      }
                    },
                    yaxis: {
                      lines: {
                        show: true
                      },
                      labels: {}
                    },
                    padding: {
                      top: 0,
                      right: 0,
                      bottom: 0,
                      left: 20
                    }
                  },
                  xaxis: {
                    type: 'datetime'
                  },
                  yaxis: {
                    labels: {},
                    title: {
                      text: 'PPM',
                      rotate: -90,
                      offsetX: 0,
                      offsetY: 0,
                      style: {
                        fontSize: '12px',
                        fontFamily: 'Helvetica, Arial, sans-serif',
                        fontWeight: 600,
                        cssClass: 'apexcharts-yaxis-title'
                      }
                    }
                  },
                  dataLabels: {
                    enabled: false
                  },
                  colors: [
                    '#b702d4',
                    '#008fd4',
                    '#dbf705',
                    '#00ff1a'
                  ],
                  annotations: {
                    yaxis: [
                      {
                        y: 0,
                        y2: 35,
                        borderColor: '#98E565',
                        fillColor: '#98E565'
                      },
                      {
                        y: 35,
                        y2: 200,
                        borderColor: '#FFEF5C',
                        fillColor: '#FFEF5C'
                      },
                      {
                        y: 200,
                        y2: 1200,
                        borderColor: '#871014',
                        fillColor: '#871014'
                      },
                      {
                        y: 1200,
                        y2: 0,
                        borderColor: '#000000',
                        fillColor: '#000000'
                      }
                    ]
                  }
                },
                type: 'normal',
                indicators: true
              },
              {
                id: '-N5dKEwePLjj-rXtHoB3T',
                name: [
                  'o3'
                ],
                title: 'Ozone',
                location: 'q7qszwc1',
                deviceNames: [
                  'B3-92C',
                  'B4-820',
                  'B1-97C',
                  'B5-7BA'
                ],
                devices: [
                  '600a0c2a69e6092c',
                  '600a0c2a69e60820',
                  '600a0c2a69e6097c',
                  '600a0c2a69e607ba'
                ],
                comparison: true,
                sensorsList: [
                  'scd41_62',
                  'mcp3424_6A',
                  'mcp3424_6E',
                  'sfa30_5D',
                  'scd42_62',
                  'sen54_69'
                ],
                options: {
                  fill: {
                    colors: [
                      '#b702d4',
                      '#008fd4',
                      '#dbf705',
                      '#00ff1a'
                    ],
                    opacity: 1
                  },
                  stroke: {
                    width: 2,
                    curve: 'straight',
                    colors: [
                      '#b702d4',
                      '#008fd4',
                      '#dbf705',
                      '#00ff1a'
                    ]
                  },
                  chart: {
                    id: 'realtime',
                    type: 'line',
                    animations: {
                      enabled: true,
                      easing: 'linear',
                      dynamicAnimation: {
                        speed: 1000
                      },
                      toolbar: {
                        show: true
                      }
                    },
                    toolbar: {
                      show: true
                    },
                    zoom: {
                      enabled: true
                    }
                  },
                  grid: {
                    borderColor: '#A3A5A6',
                    xaxis: {
                      lines: {
                        show: true
                      }
                    },
                    yaxis: {
                      lines: {
                        show: true
                      },
                      labels: {}
                    },
                    padding: {
                      top: 0,
                      right: 0,
                      bottom: 0,
                      left: 20
                    }
                  },
                  xaxis: {
                    type: 'datetime'
                  },
                  yaxis: {
                    labels: {},
                    title: {
                      text: 'PPM',
                      rotate: -90,
                      offsetX: 0,
                      offsetY: 0,
                      style: {
                        fontSize: '12px',
                        fontFamily: 'Helvetica, Arial, sans-serif',
                        fontWeight: 600,
                        cssClass: 'apexcharts-yaxis-title'
                      }
                    }
                  },
                  dataLabels: {
                    enabled: false
                  },
                  colors: [
                    '#b702d4',
                    '#008fd4',
                    '#dbf705',
                    '#00ff1a'
                  ],
                  annotations: {
                    yaxis: [
                      {
                        y: -999999,
                        y2: 0.1,
                        borderColor: '#98E565',
                        fillColor: '#98E565'
                      },
                      {
                        y: 0.1,
                        y2: 0.3,
                        borderColor: '#FFEF5C',
                        fillColor: '#FFEF5C'
                      },
                      {
                        y: 0.3,
                        y2: 5,
                        borderColor: '#871014',
                        fillColor: '#871014'
                      },
                      {
                        y: 5,
                        y2: 0,
                        borderColor: '#000000',
                        fillColor: '#000000'
                      }
                    ]
                  }
                },
                type: 'normal',
                indicators: true
              },
              {
                id: 'oQHbNbS7DAgNZTW49RWDJ',
                name: [
                  'alcohol'
                ],
                title: 'Alcohol',
                location: 'q7qszwc1',
                deviceNames: [
                  'B3-92C',
                  'B4-820',
                  'B1-97C',
                  'B5-7BA'
                ],
                devices: [
                  '600a0c2a69e6092c',
                  '600a0c2a69e60820',
                  '600a0c2a69e6097c',
                  '600a0c2a69e607ba'
                ],
                comparison: true,
                sensorsList: [
                  'mcp3424_6A',
                  'mcp3424_6E',
                  'scd41_62',
                  'sfa30_5D',
                  'sen54_69',
                  'scd42_62'
                ],
                options: {
                  fill: {
                    colors: [
                      '#b702d4',
                      '#008fd4',
                      '#dbf705',
                      '#00ff1a'
                    ],
                    opacity: 1
                  },
                  stroke: {
                    width: 2,
                    curve: 'straight',
                    colors: [
                      '#b702d4',
                      '#008fd4',
                      '#dbf705',
                      '#00ff1a'
                    ]
                  },
                  chart: {
                    id: 'realtime',
                    type: 'line',
                    animations: {
                      enabled: true,
                      easing: 'linear',
                      dynamicAnimation: {
                        speed: 1000
                      },
                      toolbar: {
                        show: true
                      }
                    },
                    toolbar: {
                      show: true
                    },
                    zoom: {
                      enabled: true
                    }
                  },
                  grid: {
                    borderColor: '#A3A5A6',
                    xaxis: {
                      lines: {
                        show: true
                      }
                    },
                    yaxis: {
                      lines: {
                        show: true
                      },
                      labels: {}
                    },
                    padding: {
                      top: 0,
                      right: 0,
                      bottom: 0,
                      left: 20
                    }
                  },
                  xaxis: {
                    type: 'datetime'
                  },
                  yaxis: {
                    labels: {},
                    title: {
                      text: 'PPM',
                      rotate: -90,
                      offsetX: 0,
                      offsetY: 0,
                      style: {
                        fontSize: '12px',
                        fontFamily: 'Helvetica, Arial, sans-serif',
                        fontWeight: 600,
                        cssClass: 'apexcharts-yaxis-title'
                      }
                    }
                  },
                  dataLabels: {
                    enabled: false
                  },
                  colors: [
                    '#b702d4',
                    '#008fd4',
                    '#dbf705',
                    '#00ff1a'
                  ],
                  annotations: {
                    yaxis: [
                      {
                        y: -1,
                        y2: 400,
                        borderColor: '#98E565',
                        fillColor: '#98E565'
                      },
                      {
                        y: 400,
                        y2: 500,
                        borderColor: '#FFEF5C',
                        fillColor: '#FFEF5C'
                      },
                      {
                        y: 500,
                        y2: 2000,
                        borderColor: '#871014',
                        fillColor: '#871014'
                      },
                      {
                        y: 2000,
                        y2: 0,
                        borderColor: '#000000',
                        fillColor: '#000000'
                      }
                    ]
                  }
                },
                type: 'normal',
                indicators: true
              },
              {
                id: '8zfCsl68aHe8Mh1oCmFQB',
                name: [
                  'cl2'
                ],
                title: 'Chlorine',
                location: 'q7qszwc1',
                deviceNames: [
                  'B3-92C',
                  'B4-820',
                  'B1-97C',
                  'B5-7BA'
                ],
                devices: [
                  '600a0c2a69e6092c',
                  '600a0c2a69e60820',
                  '600a0c2a69e6097c',
                  '600a0c2a69e607ba'
                ],
                comparison: true,
                sensorsList: [
                  'scd41_62',
                  'mcp3424_6A',
                  'mcp3424_6E',
                  'sfa30_5D',
                  'scd42_62',
                  'sen54_69'
                ],
                options: {
                  fill: {
                    colors: [
                      '#b702d4',
                      '#008fd4',
                      '#dbf705',
                      '#00ff1a'
                    ],
                    opacity: 1
                  },
                  stroke: {
                    width: 2,
                    curve: 'straight',
                    colors: [
                      '#b702d4',
                      '#008fd4',
                      '#dbf705',
                      '#00ff1a'
                    ]
                  },
                  chart: {
                    id: 'realtime',
                    type: 'line',
                    animations: {
                      enabled: true,
                      easing: 'linear',
                      dynamicAnimation: {
                        speed: 1000
                      },
                      toolbar: {
                        show: true
                      }
                    },
                    toolbar: {
                      show: true
                    },
                    zoom: {
                      enabled: true
                    }
                  },
                  grid: {
                    borderColor: '#A3A5A6',
                    xaxis: {
                      lines: {
                        show: true
                      }
                    },
                    yaxis: {
                      lines: {
                        show: true
                      },
                      labels: {}
                    },
                    padding: {
                      top: 0,
                      right: 0,
                      bottom: 0,
                      left: 20
                    }
                  },
                  xaxis: {
                    type: 'datetime'
                  },
                  yaxis: {
                    labels: {},
                    title: {
                      text: 'PPM',
                      rotate: -90,
                      offsetX: 0,
                      offsetY: 0,
                      style: {
                        fontSize: '12px',
                        fontFamily: 'Helvetica, Arial, sans-serif',
                        fontWeight: 600,
                        cssClass: 'apexcharts-yaxis-title'
                      }
                    }
                  },
                  dataLabels: {
                    enabled: false
                  },
                  colors: [
                    '#b702d4',
                    '#008fd4',
                    '#dbf705',
                    '#00ff1a'
                  ],
                  annotations: {
                    yaxis: [
                      {
                        y: -999999,
                        y2: 0.1,
                        borderColor: '#98E565',
                        fillColor: '#98E565'
                      },
                      {
                        y: 0.1,
                        y2: 0.4,
                        borderColor: '#FFEF5C',
                        fillColor: '#FFEF5C'
                      },
                      {
                        y: 0.4,
                        y2: 10,
                        borderColor: '#871014',
                        fillColor: '#871014'
                      },
                      {
                        y: 10,
                        y2: 0,
                        borderColor: '#000000',
                        fillColor: '#000000'
                      }
                    ]
                  }
                },
                type: 'normal',
                indicators: true
              },
              {
                id: 'G4nMnPYBqNPf1ZP8pl5jC',
                name: [
                  'hcho'
                ],
                title: 'Formaldehyde',
                location: 'q7qszwc1',
                deviceNames: [
                  'B3-92C',
                  'B4-820',
                  'B1-97C',
                  'B5-7BA'
                ],
                devices: [
                  '600a0c2a69e6092c',
                  '600a0c2a69e60820',
                  '600a0c2a69e6097c',
                  '600a0c2a69e607ba'
                ],
                comparison: true,
                sensorsList: [
                  'scd41_62',
                  'mcp3424_6A',
                  'mcp3424_6E',
                  'sfa30_5D',
                  'sen54_69',
                  'scd42_62'
                ],
                options: {
                  fill: {
                    colors: [
                      '#b702d4',
                      '#008fd4',
                      '#dbf705',
                      '#00ff1a'
                    ],
                    opacity: 1
                  },
                  stroke: {
                    width: 2,
                    curve: 'straight',
                    colors: [
                      '#b702d4',
                      '#008fd4',
                      '#dbf705',
                      '#00ff1a'
                    ]
                  },
                  chart: {
                    id: 'realtime',
                    type: 'line',
                    animations: {
                      enabled: true,
                      easing: 'linear',
                      dynamicAnimation: {
                        speed: 1000
                      },
                      toolbar: {
                        show: true
                      }
                    },
                    toolbar: {
                      show: true
                    },
                    zoom: {
                      enabled: true
                    }
                  },
                  grid: {
                    borderColor: '#A3A5A6',
                    xaxis: {
                      lines: {
                        show: true
                      }
                    },
                    yaxis: {
                      lines: {
                        show: true
                      },
                      labels: {}
                    },
                    padding: {
                      top: 0,
                      right: 0,
                      bottom: 0,
                      left: 20
                    }
                  },
                  xaxis: {
                    type: 'datetime'
                  },
                  yaxis: {
                    labels: {},
                    title: {
                      text: 'PPM',
                      rotate: -90,
                      offsetX: 0,
                      offsetY: 0,
                      style: {
                        fontSize: '12px',
                        fontFamily: 'Helvetica, Arial, sans-serif',
                        fontWeight: 600,
                        cssClass: 'apexcharts-yaxis-title'
                      }
                    }
                  },
                  dataLabels: {
                    enabled: false
                  },
                  colors: [
                    '#b702d4',
                    '#008fd4',
                    '#dbf705',
                    '#00ff1a'
                  ],
                  annotations: {
                    yaxis: [
                      {
                        y: -999999,
                        y2: 0.3,
                        borderColor: '#98E565',
                        fillColor: '#98E565'
                      },
                      {
                        y: 0.3,
                        y2: 1,
                        borderColor: '#FFEF5C',
                        fillColor: '#FFEF5C'
                      },
                      {
                        y: 1,
                        y2: 20,
                        borderColor: '#871014',
                        fillColor: '#871014'
                      },
                      {
                        y: 20,
                        y2: 0,
                        borderColor: '#000000',
                        fillColor: '#000000'
                      }
                    ]
                  }
                },
                type: 'normal',
                indicators: true
              },
              {
                id: 'm3Qe5FPc3EkVzivv7VvQL',
                name: [
                  'h2o2'
                ],
                title: 'Hydrogen Peroxide',
                location: 'q7qszwc1',
                deviceNames: [
                  'B3-92C',
                  'B4-820',
                  'B1-97C',
                  'B5-7BA'
                ],
                devices: [
                  '600a0c2a69e6092c',
                  '600a0c2a69e60820',
                  '600a0c2a69e6097c',
                  '600a0c2a69e607ba'
                ],
                comparison: true,
                sensorsList: [
                  'scd41_62',
                  'mcp3424_6A',
                  'mcp3424_6E',
                  'sfa30_5D',
                  'sen54_69',
                  'scd42_62'
                ],
                options: {
                  fill: {
                    colors: [
                      '#b702d4',
                      '#008fd4',
                      '#dbf705',
                      '#00ff1a'
                    ],
                    opacity: 1
                  },
                  stroke: {
                    width: 2,
                    curve: 'straight',
                    colors: [
                      '#b702d4',
                      '#008fd4',
                      '#dbf705',
                      '#00ff1a'
                    ]
                  },
                  chart: {
                    id: 'realtime',
                    type: 'line',
                    animations: {
                      enabled: true,
                      easing: 'linear',
                      dynamicAnimation: {
                        speed: 1000
                      },
                      toolbar: {
                        show: true
                      }
                    },
                    toolbar: {
                      show: true
                    },
                    zoom: {
                      enabled: true
                    }
                  },
                  grid: {
                    borderColor: '#A3A5A6',
                    xaxis: {
                      lines: {
                        show: true
                      }
                    },
                    yaxis: {
                      lines: {
                        show: true
                      },
                      labels: {}
                    },
                    padding: {
                      top: 0,
                      right: 0,
                      bottom: 0,
                      left: 20
                    }
                  },
                  xaxis: {
                    type: 'datetime'
                  },
                  yaxis: {
                    labels: {},
                    title: {
                      text: 'PPM',
                      rotate: -90,
                      offsetX: 0,
                      offsetY: 0,
                      style: {
                        fontSize: '12px',
                        fontFamily: 'Helvetica, Arial, sans-serif',
                        fontWeight: 600,
                        cssClass: 'apexcharts-yaxis-title'
                      }
                    }
                  },
                  dataLabels: {
                    enabled: false
                  },
                  colors: [
                    '#b702d4',
                    '#008fd4',
                    '#dbf705',
                    '#00ff1a'
                  ],
                  annotations: {
                    yaxis: [
                      {
                        y: -999999,
                        y2: 1,
                        borderColor: '#98E565',
                        fillColor: '#98E565'
                      },
                      {
                        y: 1,
                        y2: 25,
                        borderColor: '#FFEF5C',
                        fillColor: '#FFEF5C'
                      },
                      {
                        y: 25,
                        y2: 75,
                        borderColor: '#871014',
                        fillColor: '#871014'
                      },
                      {
                        y: 75,
                        y2: 0,
                        borderColor: '#000000',
                        fillColor: '#000000'
                      }
                    ]
                  }
                },
                type: 'normal',
                indicators: true
              },
              {
                id: 'EmzaD6mSfKptF-2GHAelY',
                name: [
                  'no2'
                ],
                title: 'Nitrogen Dioxide',
                location: 'q7qszwc1',
                deviceNames: [
                  'B3-92C',
                  'B4-820',
                  'B1-97C',
                  'B5-7BA'
                ],
                devices: [
                  '600a0c2a69e6092c',
                  '600a0c2a69e60820',
                  '600a0c2a69e6097c',
                  '600a0c2a69e607ba'
                ],
                comparison: true,
                sensorsList: [
                  'scd41_62',
                  'mcp3424_6A',
                  'mcp3424_6E',
                  'sfa30_5D',
                  'sen54_69',
                  'scd42_62'
                ],
                options: {
                  fill: {
                    colors: [
                      '#b702d4',
                      '#008fd4',
                      '#dbf705',
                      '#00ff1a'
                    ],
                    opacity: 1
                  },
                  stroke: {
                    width: 2,
                    curve: 'straight',
                    colors: [
                      '#b702d4',
                      '#008fd4',
                      '#dbf705',
                      '#00ff1a'
                    ]
                  },
                  chart: {
                    id: 'realtime',
                    type: 'line',
                    animations: {
                      enabled: true,
                      easing: 'linear',
                      dynamicAnimation: {
                        speed: 1000
                      },
                      toolbar: {
                        show: true
                      }
                    },
                    toolbar: {
                      show: true
                    },
                    zoom: {
                      enabled: true
                    }
                  },
                  grid: {
                    borderColor: '#A3A5A6',
                    xaxis: {
                      lines: {
                        show: true
                      }
                    },
                    yaxis: {
                      lines: {
                        show: true
                      },
                      labels: {}
                    },
                    padding: {
                      top: 0,
                      right: 0,
                      bottom: 0,
                      left: 20
                    }
                  },
                  xaxis: {
                    type: 'datetime'
                  },
                  yaxis: {
                    labels: {},
                    title: {
                      text: 'PPM',
                      rotate: -90,
                      offsetX: 0,
                      offsetY: 0,
                      style: {
                        fontSize: '12px',
                        fontFamily: 'Helvetica, Arial, sans-serif',
                        fontWeight: 600,
                        cssClass: 'apexcharts-yaxis-title'
                      }
                    }
                  },
                  dataLabels: {
                    enabled: false
                  },
                  colors: [
                    '#b702d4',
                    '#008fd4',
                    '#dbf705',
                    '#00ff1a'
                  ],
                  annotations: {
                    yaxis: [
                      {
                        y: -999999,
                        y2: 0.2,
                        borderColor: '#98E565',
                        fillColor: '#98E565'
                      },
                      {
                        y: 0.2,
                        y2: 1,
                        borderColor: '#FFEF5C',
                        fillColor: '#FFEF5C'
                      },
                      {
                        y: 1,
                        y2: 20,
                        borderColor: '#871014',
                        fillColor: '#871014'
                      },
                      {
                        y: 20,
                        y2: 0,
                        borderColor: '#000000',
                        fillColor: '#000000'
                      }
                    ]
                  }
                },
                type: 'normal',
                indicators: true
              },
              {
                id: 'bL4ngQcG2GcCinxbtV-7I',
                name: [
                  'so2'
                ],
                title: 'Sulfur Dioxide',
                location: 'q7qszwc1',
                deviceNames: [
                  'B3-92C',
                  'B4-820',
                  'B1-97C',
                  'B5-7BA'
                ],
                devices: [
                  '600a0c2a69e6092c',
                  '600a0c2a69e60820',
                  '600a0c2a69e6097c',
                  '600a0c2a69e607ba'
                ],
                comparison: true,
                sensorsList: [
                  'scd41_62',
                  'mcp3424_6A',
                  'mcp3424_6E',
                  'sfa30_5D',
                  'scd42_62',
                  'sen54_69'
                ],
                options: {
                  fill: {
                    colors: [
                      '#b702d4',
                      '#008fd4',
                      '#dbf705',
                      '#00ff1a'
                    ],
                    opacity: 1
                  },
                  stroke: {
                    width: 2,
                    curve: 'straight',
                    colors: [
                      '#b702d4',
                      '#008fd4',
                      '#dbf705',
                      '#00ff1a'
                    ]
                  },
                  chart: {
                    id: 'realtime',
                    type: 'line',
                    animations: {
                      enabled: true,
                      easing: 'linear',
                      dynamicAnimation: {
                        speed: 1000
                      },
                      toolbar: {
                        show: true
                      }
                    },
                    toolbar: {
                      show: true
                    },
                    zoom: {
                      enabled: true
                    }
                  },
                  grid: {
                    borderColor: '#A3A5A6',
                    xaxis: {
                      lines: {
                        show: true
                      }
                    },
                    yaxis: {
                      lines: {
                        show: true
                      },
                      labels: {}
                    },
                    padding: {
                      top: 0,
                      right: 0,
                      bottom: 0,
                      left: 20
                    }
                  },
                  xaxis: {
                    type: 'datetime'
                  },
                  yaxis: {
                    labels: {},
                    title: {
                      text: 'PPM',
                      rotate: -90,
                      offsetX: 0,
                      offsetY: 0,
                      style: {
                        fontSize: '12px',
                        fontFamily: 'Helvetica, Arial, sans-serif',
                        fontWeight: 600,
                        cssClass: 'apexcharts-yaxis-title'
                      }
                    }
                  },
                  dataLabels: {
                    enabled: false
                  },
                  colors: [
                    '#b702d4',
                    '#008fd4',
                    '#dbf705',
                    '#00ff1a'
                  ],
                  annotations: {
                    yaxis: [
                      {
                        y: -999999,
                        y2: 0.25,
                        borderColor: '#98E565',
                        fillColor: '#98E565'
                      },
                      {
                        y: 0.25,
                        y2: 5,
                        borderColor: '#FFEF5C',
                        fillColor: '#FFEF5C'
                      },
                      {
                        y: 5,
                        y2: 100,
                        borderColor: '#871014',
                        fillColor: '#871014'
                      },
                      {
                        y: 100,
                        y2: 0,
                        borderColor: '#000000',
                        fillColor: '#000000'
                      }
                    ]
                  }
                },
                type: 'normal',
                indicators: true
              },
              {
                id: 'XsSFrlaU7ezcn5fS-T1N1',
                name: [
                  'nh3'
                ],
                title: 'Ammonia (NH3)',
                location: 'q7qszwc1',
                deviceNames: [
                  'B3-92C',
                  'B4-820',
                  'B1-97C',
                  'B5-7BA'
                ],
                devices: [
                  '600a0c2a69e6092c',
                  '600a0c2a69e60820',
                  '600a0c2a69e6097c',
                  '600a0c2a69e607ba'
                ],
                comparison: true,
                sensorsList: [
                  'scd41_62',
                  'mcp3424_6A',
                  'mcp3424_6E',
                  'sfa30_5D',
                  'sen54_69',
                  'scd42_62'
                ],
                options: {
                  fill: {
                    colors: [
                      '#b702d4',
                      '#008fd4',
                      '#dbf705',
                      '#00ff1a'
                    ],
                    opacity: 1
                  },
                  stroke: {
                    width: 2,
                    curve: 'straight',
                    colors: [
                      '#b702d4',
                      '#008fd4',
                      '#dbf705',
                      '#00ff1a'
                    ]
                  },
                  chart: {
                    id: 'realtime',
                    type: 'line',
                    animations: {
                      enabled: true,
                      easing: 'linear',
                      dynamicAnimation: {
                        speed: 1000
                      },
                      toolbar: {
                        show: true
                      }
                    },
                    toolbar: {
                      show: true
                    },
                    zoom: {
                      enabled: true
                    }
                  },
                  grid: {
                    borderColor: '#A3A5A6',
                    xaxis: {
                      lines: {
                        show: true
                      }
                    },
                    yaxis: {
                      lines: {
                        show: true
                      },
                      labels: {}
                    },
                    padding: {
                      top: 0,
                      right: 0,
                      bottom: 0,
                      left: 20
                    }
                  },
                  xaxis: {
                    type: 'datetime'
                  },
                  yaxis: {
                    labels: {},
                    title: {
                      text: 'PPM',
                      rotate: -90,
                      offsetX: 0,
                      offsetY: 0,
                      style: {
                        fontSize: '12px',
                        fontFamily: 'Helvetica, Arial, sans-serif',
                        fontWeight: 600,
                        cssClass: 'apexcharts-yaxis-title'
                      }
                    }
                  },
                  dataLabels: {
                    enabled: false
                  },
                  colors: [
                    '#b702d4',
                    '#008fd4',
                    '#dbf705',
                    '#00ff1a'
                  ],
                  annotations: {
                    yaxis: [
                      {
                        y: -99999,
                        y2: 25,
                        borderColor: '#98E565',
                        fillColor: '#98E565'
                      },
                      {
                        y: 25,
                        y2: 35,
                        borderColor: '#FFEF5C',
                        fillColor: '#FFEF5C'
                      },
                      {
                        y: 35,
                        y2: 220,
                        borderColor: '#871014',
                        fillColor: '#871014'
                      },
                      {
                        y: 220,
                        y2: 0,
                        borderColor: '#000000',
                        fillColor: '#000000'
                      }
                    ]
                  }
                },
                type: 'normal',
                indicators: true
              },
              {
                id: 'h_FeHCPil6Uk26z_tJLaD',
                indicators: true,
                name: [
                  'thi'
                ],
                title: 'THI',
                location: 'q7qszwc1',
                deviceNames: [
                  'B3-92C',
                  'B4-820',
                  'B5-7BA'
                ],
                devices: [
                  '600a0c2a69e6092c',
                  '600a0c2a69e60820',
                  '600a0c2a69e607ba'
                ],
                comparison: true,
                sensorsList: [
                  'scd41_62',
                  'mcp3424_6A',
                  'mcp3424_6E',
                  'sfa30_5D',
                  'sen54_69',
                  'scd42_62'
                ],
                options: {
                  fill: {
                    colors: [
                      '#b702d4',
                      '#008fd4',
                      '#dbf705'
                    ],
                    opacity: 1
                  },
                  stroke: {
                    width: 2,
                    curve: 'straight',
                    colors: [
                      '#b702d4',
                      '#008fd4',
                      '#dbf705'
                    ]
                  },
                  chart: {
                    id: 'realtime',
                    type: 'area',
                    animations: {
                      enabled: false,
                      easing: 'linear',
                      dynamicAnimation: {
                        speed: 1000
                      },
                      toolbar: {
                        show: true
                      }
                    },
                    toolbar: {
                      show: true
                    },
                    zoom: {
                      enabled: true
                    }
                  },
                  grid: {
                    borderColor: '#dcdce0',
                    xaxis: {
                      lines: {
                        show: true
                      }
                    },
                    yaxis: {
                      lines: {
                        show: true
                      },
                      labels: {}
                    },
                    padding: {
                      top: 0,
                      right: 0,
                      bottom: 0,
                      left: 20
                    }
                  },
                  xaxis: {
                    type: 'datetime'
                  },
                  yaxis: {
                    labels: {},
                    title: {
                      text: '',
                      rotate: -90,
                      offsetX: 0,
                      offsetY: 0,
                      style: {
                        fontSize: '12px',
                        fontFamily: 'Helvetica, Arial, sans-serif',
                        fontWeight: 400,
                        cssClass: 'apexcharts-yaxis-title'
                      }
                    }
                  },
                  annotations: {
                    yaxis: []
                  },
                  dataLabels: {
                    enabled: false
                  },
                  colors: [
                    '#b702d4',
                    '#008fd4',
                    '#dbf705'
                  ]
                },
                type: 'normal'
              },
              {
                id: 'cT8DHK3Nge7QOrmctGCrn',
                indicators: true,
                name: [
                  'thir'
                ],
                title: 'RF',
                location: 'q7qszwc1',
                deviceNames: [
                  'B3-92C',
                  'B4-820',
                  'B1-97C',
                  'B5-7BA'
                ],
                devices: [
                  '600a0c2a69e6092c',
                  '600a0c2a69e60820',
                  '600a0c2a69e6097c',
                  '600a0c2a69e607ba'
                ],
                comparison: true,
                sensorsList: [
                  'scd41_62',
                  'mcp3424_6A',
                  'mcp3424_6E',
                  'sfa30_5D',
                  'sen54_69',
                  'scd42_62'
                ],
                options: {
                  fill: {
                    colors: [
                      '#b702d4',
                      '#008fd4',
                      '#dbf705',
                      '#00ff1a'
                    ],
                    opacity: 1
                  },
                  stroke: {
                    width: 2,
                    curve: 'straight',
                    colors: [
                      '#b702d4',
                      '#008fd4',
                      '#dbf705',
                      '#00ff1a'
                    ]
                  },
                  chart: {
                    id: 'realtime',
                    type: 'area',
                    animations: {
                      enabled: false,
                      easing: 'linear',
                      dynamicAnimation: {
                        speed: 1000
                      },
                      toolbar: {
                        show: true
                      }
                    },
                    toolbar: {
                      show: true
                    },
                    zoom: {
                      enabled: true
                    }
                  },
                  grid: {
                    borderColor: '#dcdce0',
                    xaxis: {
                      lines: {
                        show: true
                      }
                    },
                    yaxis: {
                      lines: {
                        show: true
                      },
                      labels: {}
                    },
                    padding: {
                      top: 0,
                      right: 0,
                      bottom: 0,
                      left: 20
                    }
                  },
                  xaxis: {
                    type: 'datetime'
                  },
                  yaxis: {
                    labels: {},
                    title: {
                      text: '',
                      rotate: -90,
                      offsetX: 0,
                      offsetY: 0,
                      style: {
                        fontSize: '12px',
                        fontFamily: 'Helvetica, Arial, sans-serif',
                        fontWeight: 400,
                        cssClass: 'apexcharts-yaxis-title'
                      }
                    }
                  },
                  annotations: {
                    yaxis: []
                  },
                  dataLabels: {
                    enabled: false
                  },
                  colors: [
                    '#b702d4',
                    '#008fd4',
                    '#dbf705',
                    '#00ff1a'
                  ]
                },
                type: 'normal'
              }
            ],
  grafanaLayout:[
              {
                w: 18,
                h: 13,
                x: 0,
                y: 0,
                i: 'LMM5ZwPRYdjD1bVfaBLsV',
                moved: false,
                'static': false
              },
              {
                w: 18,
                h: 13,
                x: 18,
                y: 0,
                i: '59WUGFxSqxNRvah1Ny6QU',
                moved: false,
                'static': false
              },
              {
                w: 24,
                h: 12,
                x: 0,
                y: 13,
                i: 'Tkp5ZneMhxWC-s9xdoyrA',
                moved: false,
                'static': false
              },
              {
                w: 24,
                h: 12,
                x: 24,
                y: 13,
                i: 'r5MIV7ZQ_pmSr2FL-2YZm',
                moved: false,
                'static': false
              },
              {
                w: 36,
                h: 12,
                x: 0,
                y: 25,
                i: 'Px9nAv4NB3jfnxDTAsu30',
                moved: false,
                'static': false
              },
              {
                w: 36,
                h: 12,
                x: 36,
                y: 25,
                i: '6gyo5x3GRxxJed-_V891o',
                moved: false,
                'static': false
              },
              {
                w: 18,
                h: 13,
                x: 54,
                y: 0,
                i: 'ap9gjqQIlqKGkR9whZe6b',
                moved: false,
                'static': false
              },
              {
                w: 36,
                h: 12,
                x: 0,
                y: 37,
                i: 'xfSCFsA0Syn9ql6y_5CX_',
                moved: false,
                'static': false
              },
              {
                w: 36,
                h: 12,
                x: 36,
                y: 37,
                i: 'NZLkDlmNLxgVPYpRLdB0d',
                moved: false,
                'static': false
              },
              {
                w: 72,
                h: 13,
                x: 0,
                y: 49,
                i: 'avoQOIYLYMGTby25S1UEe',
                moved: false,
                'static': false
              },
              {
                w: 36,
                h: 12,
                x: 0,
                y: 74,
                i: 'chx7OxsOmFVWjpsGbEEks',
                moved: false,
                'static': false
              },
              {
                w: 36,
                h: 12,
                x: 0,
                y: 62,
                i: 'wZRRU-m-arVHW3UYPSB5O',
                moved: false,
                'static': false
              },
              {
                w: 36,
                h: 12,
                x: 36,
                y: 62,
                i: 'M3x1B1WWUAS5fHEpU2lND',
                moved: false,
                'static': false
              },
              {
                w: 36,
                h: 12,
                x: 36,
                y: 74,
                i: 'XnyrrxOZNjoKg7mICwRdl',
                moved: false,
                'static': false
              },
              {
                w: 24,
                h: 12,
                x: 0,
                y: 86,
                i: 'LJfzeH083nTpFb8TY1tJn',
                moved: false,
                'static': false
              },
              {
                w: 24,
                h: 12,
                x: 48,
                y: 86,
                i: 'Yg0FH5W14NxcYhMdMChv6',
                moved: false,
                'static': false
              },
              {
                w: 24,
                h: 12,
                x: 24,
                y: 86,
                i: '-N5dKEwePLjj-rXtHoB3T',
                moved: false,
                'static': false
              },
              {
                w: 18,
                h: 12,
                x: 18,
                y: 98,
                i: 'oQHbNbS7DAgNZTW49RWDJ',
                moved: false,
                'static': false
              },
              {
                w: 18,
                h: 12,
                x: 54,
                y: 98,
                i: '8zfCsl68aHe8Mh1oCmFQB',
                moved: false,
                'static': false
              },
              {
                w: 18,
                h: 12,
                x: 0,
                y: 98,
                i: 'G4nMnPYBqNPf1ZP8pl5jC',
                moved: false,
                'static': false
              },
              {
                w: 24,
                h: 12,
                x: 48,
                y: 13,
                i: 'm3Qe5FPc3EkVzivv7VvQL',
                moved: false,
                'static': false
              },
              {
                w: 18,
                h: 12,
                x: 36,
                y: 98,
                i: 'EmzaD6mSfKptF-2GHAelY',
                moved: false,
                'static': false
              },
              {
                w: 24,
                h: 13,
                x: 0,
                y: 110,
                i: 'bL4ngQcG2GcCinxbtV-7I',
                moved: false,
                'static': false
              },
              {
                w: 18,
                h: 13,
                x: 36,
                y: 0,
                i: 'XsSFrlaU7ezcn5fS-T1N1',
                moved: false,
                'static': false
              },
              {
                w: 23,
                h: 13,
                x: 24,
                y: 110,
                i: 'h_FeHCPil6Uk26z_tJLaD',
                moved: false,
                'static': false
              },
              {
                w: 25,
                h: 13,
                x: 47,
                y: 110,
                i: 'cT8DHK3Nge7QOrmctGCrn',
                moved: false,
                'static': false
              }
            ],
};
